// extracted by mini-css-extract-plugin
export default {"section":"AddInterests_section__ma1x+","label":"AddInterests_label__BFbLb"};